/////////////////////////////////////////////
//Dependencies
import React from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////
//Imported Components
import ParseText from "../parseText/ParseText";

/////////////////////////////////////////////
//CSS
import "./Chiffre.css";

/////////////////////////////////////////////
//Component

/**
 * C
 *
 * @returns {JSX.Element} - The rendered Chiffres component.
 */
export default function Chiffre() {
    const { t } = useTranslation();

    const stats = [
        { icon: "i-machi.png", value: "+500", labelKey: "chiffre.systems" },
        { icon: "i-collab.png", value: "+30", labelKey: "chiffre.years" },
        { icon: "i-client.png", value: "+10", labelKey: "chiffre.vacsyspy" },
        { icon: "i-monde.png", value: "80%", labelKey: "chiffre.export" },
    ];

    return (
        <div className="chiffres">
            <div className="title-container">
                <img
                    className="PLASSYS-logo"
                    src="../img/logo/plassys-logo.png"
                    alt="PLASSYS Bestek logo"
                    draggable="false"
                />
            </div>

            <div className="chiffres-grid">
                {stats.map((stat, i) => (
                    <div className="chiffres-card" key={i}>
                        <div className="chiffres-card-icon">
                            <img
                                src={`../img/icones/${stat.icon}`}
                                alt=""
                                aria-hidden="true"
                                draggable="false"
                            />
                        </div>
                        <div className="chiffres-card-value">{stat.value}</div>
                        <ParseText 
                            classN="chiffres-card-label" 
                            text={t(stat.labelKey)} 
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
